
/**
 * Конвертирует темп из десятичных минут (5.99) в формат М:СС (5:59).
 * avg_pace_min_per_km хранится как decimal minutes = duration_min / distance_km,
 * а не как минуты:секунды напрямую — отсюда путаница в отображении.
 */
export function formatPace(decimalMinPerKm) {
  if (decimalMinPerKm == null || isNaN(decimalMinPerKm)) return '—';

  let minutes = Math.floor(decimalMinPerKm);
  let seconds = Math.round((decimalMinPerKm - minutes) * 60);

  // защита от округления до 60 секунд
  if (seconds === 60) {
    seconds = 0;
    minutes += 1;
  }

  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
 